import React from 'react';

const Card = ({ children, as: Component = 'div', ariaLabel, ...props }) => {
  return (
    <Component
      className="sl-radius-m sl-flex sl-flex-col sl-bg-primary sl-gutter-l sl-grow-1 sl-gap"
      aria-label={ariaLabel}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Card;
